import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      textAlign: 'start'
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      height: '39px'
    },
    error: {
      color: palette.common.red
    },
    policy: {
      display: 'flex',
      gap: '20px',
      marginTop: '10px',
      alignItems: 'center',
      '@media (max-width: 724px)': {
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '10px'
      }
    },
    link: {
      color: palette.text.primary,
      textDecoration: 'none',
      '@media (max-width: 724px)': {
        textDecoration: 'underline'
      },
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    inputs: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    inputError: {
      margin: '5px 10px',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '17px',
      fontStyle: 'normal',
      color: palette.danger.red
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
